import { COLOR_FROM_CLASSIFICATION, ICON_FROM_CLASSIFICATION } from "library/SFG20/constants.mjs"
import Iconify from "minimals-template/components/Iconify"

export function PdfTaskClassificationMarker({ classification }) {
    const icon = ICON_FROM_CLASSIFICATION[classification]
    const color = COLOR_FROM_CLASSIFICATION[classification] ?? "#7b8794"
    if (!icon) return null

    return <Iconify icon={icon} width={14} height={14} style={{ color, flex: "0 0 auto" }} />
}
